<div class="fdx-u-align--center">
  <br><br><br>
  <div class="fdx-c-loading-indicator fdx-c-loading-indicator--large">
    <div class="fdx-c-loading-indicator__part"></div>
    <div class="fdx-c-loading-indicator__part"></div>
    <div class="fdx-c-loading-indicator__part"></div>
    <div class="fdx-c-loading-indicator__part"></div>
  </div>
</div>
